var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({staticClass:"static-link",attrs:{"to":{ name: _vm.routeName }}},'router-link',_vm.$attrs,false),[_vm._v("\n    "+_vm._s(_vm._f("capitalize")(_vm.$t(_vm.label)))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36cb74a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/layout/footer/components/CustomRouterLink.vue
// module id = 1842
// module chunks = 0